// Page mentions légales — Hsasoft / HInvoice
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../assets/logo.png";

export function LegalPage() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <main className="min-h-screen bg-slate-50 py-12 px-6">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="mb-8 flex items-center gap-4">
          <Link to="/">
            <img src={logo} alt="HInvoice" className="h-12 w-auto" />
          </Link>
          <div>
            <h1 className="text-2xl font-bold text-slate-900">{t("legal.title")}</h1>
            <p className="text-sm text-slate-500">{t("legal.subtitle")}</p>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8 space-y-8 text-sm text-slate-700 leading-relaxed">

          {/* Éditeur */}
          <section>
            <h2 className="text-base font-semibold text-slate-900 mb-3">{t("legal.editorTitle")}</h2>
            <ul className="space-y-1">
              <li><span className="font-medium">{t("legal.company")} :</span> Hsasoft</li>
              <li><span className="font-medium">{t("legal.product")} :</span> HInvoice</li>
              <li><span className="font-medium">{t("legal.licence")} :</span> 996544</li>
              <li><span className="font-medium">{t("legal.address")} :</span> {t("legal.addressValue")}</li>
              <li>
                <span className="font-medium">{t("legal.email")} :</span>{" "}
                <a href="mailto:contact@hsasoft.com" className="text-brand-600 hover:underline">
                  contact@hsasoft.com
                </a>
              </li>
            </ul>
          </section>

          {/* Hébergement */}
          <section>
            <h2 className="text-base font-semibold text-slate-900 mb-3">{t("legal.hostingTitle")}</h2>
            <p>{t("legal.hostingText")}</p>
          </section>

          {/* Propriété intellectuelle */}
          <section>
            <h2 className="text-base font-semibold text-slate-900 mb-3">{t("legal.ipTitle")}</h2>
            <p>{t("legal.ipText")}</p>
          </section>

          {/* Données personnelles */}
          <section>
            <h2 className="text-base font-semibold text-slate-900 mb-3">{t("legal.dataTitle")}</h2>
            <p>{t("legal.dataText")}</p>
            <p className="mt-2">
              {t("legal.dataText2")}{" "}
              <a href="mailto:contact@hsasoft.com" className="text-brand-600 hover:underline">
                contact@hsasoft.com
              </a>
              .
            </p>
          </section>

          {/* Responsabilité */}
          <section>
            <h2 className="text-base font-semibold text-slate-900 mb-3">{t("legal.liabilityTitle")}</h2>
            <p>{t("legal.liabilityText")}</p>
          </section>

          {/* Droit applicable */}
          <section>
            <h2 className="text-base font-semibold text-slate-900 mb-3">{t("legal.lawTitle")}</h2>
            <p>{t("legal.lawText")}</p>
          </section>

          <p className="text-xs text-slate-400 pt-4 border-t border-slate-100">
            {t("legal.updated")} {year}
          </p>
        </div>

        <div className="mt-6 text-center">
          <Link to="/" className="text-sm text-brand-600 hover:underline">
            {t("legal.backLink")}
          </Link>
        </div>
      </div>
    </main>
  );
}
